import { useState } from "react";

import { FeatureLike } from "ol/Feature";
import { fromLonLat } from "ol/proj";
import { PopoverBody } from "react-bootstrap";

import MapClick from "@evr/components/ReactOL/Interactions/MapClick";
import { PopupOverlay } from "@evr/components/ReactOL/overlays";
import { MapLayerNames } from "@evr/constant";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectedScheduledJourney } from "@evr/store/slices/scheduled-journey-results";

const ScheduledJourneyDepotInfo = () => {
  const [show, setShow] = useState(false);
  const scheduledJourney = useAppSelector(selectedScheduledJourney);
  const depot = scheduledJourney?.depot;

  const mapClick = (e: FeatureLike[]) => {
    if (e.length) {
      setShow(!show);
    } else {
      setShow(false);
    }
  };

  return (
    <>
      <MapClick layerNames={[MapLayerNames.SCHEDULED_JOURNEY_DEPOT]} onClick={mapClick} />
      <PopupOverlay
        offset={[0, -40]}
        coordinate={show ? fromLonLat(depot?.point.coordinates ?? [0, 0]) : undefined}
        placement="top"
      >
        <PopoverBody className="p-0" style={{ borderRadius: 7 }}>
          <div className="p-2 text-nowrap text-left">
            <p className="mb-2">This is your selected Depot location for this journey.</p>
            <p className="my-0">
              <strong>Name: </strong> {depot?.name}{" "}
            </p>
            <p className="my-0">
              <strong>Latitude:</strong> {depot?.point.coordinates[1].toFixed(5)}{" "}
            </p>
            <p className="my-0">
              <strong>Longitude: </strong> {depot?.point.coordinates[0].toFixed(5)}{" "}
            </p>
          </div>
        </PopoverBody>
      </PopupOverlay>
    </>
  );
};

export default ScheduledJourneyDepotInfo;
